import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { AppFrame, TopBar } from "@/components/Shell";
import { toast } from "sonner";

export default function AdminLogin() {
  const nav = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("owner@butterfly.store");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      nav("/admin");
    } catch (err) {
      toast.error("Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AppFrame>
      <TopBar title="Owner Login" subtitle="Admin" onBack={() => nav("/")} />
      <form onSubmit={submit} className="px-5 mt-10 space-y-5">
        <div className="text-center pb-2">
          <img src="/logo-full.png" alt="Butterfly The Fashion Store" className="h-16 w-auto mx-auto" />
        </div>
        <div>
          <div className="font-display text-3xl leading-tight">Welcome back</div>
          <p className="text-sm text-neutral-500 mt-1">Sign in to manage your catalogue</p>
        </div>
        <div>
          <label className="text-[10px] uppercase tracking-[0.2em] text-neutral-500">Email</label>
          <input
            data-testid="login-email-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-1 w-full h-12 rounded-2xl border border-black/10 px-4 text-sm outline-none focus:border-neutral-900"
          />
        </div>
        <div>
          <label className="text-[10px] uppercase tracking-[0.2em] text-neutral-500">Password</label>
          <input
            data-testid="login-password-input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="mt-1 w-full h-12 rounded-2xl border border-black/10 px-4 text-sm outline-none focus:border-neutral-900"
          />
        </div>
        <button
          data-testid="login-submit-btn"
          disabled={loading}
          type="submit"
          className="w-full h-12 rounded-full bg-neutral-900 text-white text-sm font-medium press disabled:opacity-60"
        >
          {loading ? "Signing in..." : "Sign in"}
        </button>
        <p className="text-xs text-neutral-400 text-center">Contact your admin if you don't have credentials.</p>
      </form>
    </AppFrame>
  );
}
